<ng-container *ngIf="(cTransations$ | async) as cTransations">

  <div appFlex class="h-100-p w-100-p" appFlexLayout="row">
    <div appFlex>
      <!-- BALANCE WIDGET -->
      <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="pb-0">
        <!-- Front -->
        <div class="fuse-widget-front">
          <div class="p-16 pb-24" appFlexLayout="column" appFlexAlign="center center">
            <div class="h1 secondary-text">
              <span>Balance</span>
            </div>
            <div class="font-size-48 line-height-88 secondary-text font-weight-400">{{ cTransations?.balance?.balance | currency}}</div>
            <div class="h1 secondary-text"><span>USD</span></div>
          </div>
        </div>
        <!-- / Front -->
      </fuse-widget>
      <!-- / BALANCE WIDGET -->
    </div>
    <div appFlex>
      <!-- BALANCE WIDGET -->
      <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="pb-0">
        <!-- Front -->
        <div class="fuse-widget-front">
          <div class="p-16 pb-24" appFlexLayout="column" appFlexAlign="center center">
            <div class="h1 secondary-text">
              <span>Credit</span>
            </div>
            <div class="font-size-48 line-height-88 secondary-text font-weight-400">{{ cTransations?.balance?.credit | currency}}</div>
            <div class="h1 secondary-text"><span>USD</span></div>
          </div>
        </div>
        <!-- / Front -->
      </fuse-widget>
      <!-- / BALANCE WIDGET -->
    </div>
    <div appFlex>
      <!-- BALANCE WIDGET -->
      <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="pb-0">
        <!-- Front -->
        <div class="fuse-widget-front">
          <div class="p-16 pb-24" appFlexLayout="column" appFlexAlign="center center">
            <div class="h1 secondary-text">
              <span>Debit</span>
            </div>
            <div class="font-size-48 line-height-88 secondary-text font-weight-400">{{ cTransations?.balance?.debit | currency}}</div>
            <div class="h1 secondary-text"><span>USD</span></div>
          </div>
        </div>
        <!-- / Front -->
      </fuse-widget>
      <!-- / BALANCE WIDGET -->
    </div>
  </div>

  <div appFlex="auto">
    <app-add-credit-to-contributors [selectedUsersId]="[cTransations.contributorId]"></app-add-credit-to-contributors>
  </div>

  <div appFlex="grow" class="h-100-p w-100-p" style="overflow: hidden;">
    <div class="grid-container">
      <dx-data-grid
        #transactionsGrid
        *ngIf="cTransations.detail"

        [hoverStateEnabled]="true"
        keyExpr="transactionId"

        [dataSource]="cTransations.detail"
        [columns]="columns"
        [height]="'100%'"
        [width]="'100%'"

        [columnAutoWidth]="true"

        [allowColumnReordering]="true"
        [allowColumnResizing]="true"

        [showColumnLines]="false"
        [showRowLines]="false"
        [showBorders]="true"
        [rowAlternationEnabled]="false"

      >
        <dxo-selection mode="single"></dxo-selection>
        <dxo-search-panel [visible]="true" [width]="'70%'" [placeholder]="'Rechercher...' | translate"></dxo-search-panel>
        <dxo-filter-panel [visible]="true"></dxo-filter-panel>
        <dxo-group-panel [visible]="false"></dxo-group-panel>

        <dxo-scrolling mode="virtual"></dxo-scrolling>

        <div *dxTemplate="let d of 'referenceOrderIDTemplate'">
          <button *ngIf="d.data.type === 'tango' && d?.data?.confirmationToken"
                  [disabled]="(tangoCardsService.isResending$|async)?.[d.data.confirmationToken]"
                  mat-stroked-button
                  (click)="resendOrder(d?.data?.confirmationToken)">
            <mat-icon>mail</mat-icon>
            {{d.data.confirmationToken}}
          </button>
        </div>

      </dx-data-grid>
    </div>
  </div>

</ng-container>
